import "./styles.scss";
import React from "react";

const PostAuthor = ({ data }) => {
  if (!!!data?.author?.node?.acfAuthor?.postAuthorName) return null;

  return (
    <div className="single-post-main__author">
      <h2>O autorze</h2>

      <div className="single-post-main__author__content">
        <div className="single-post-main__author__left">
          {data?.author?.node?.acfAuthor?.postAuthorImage?.sourceUrl && (
            <div
              className="single-post-main__author-image"
              style={{
                backgroundImage: `url('${data?.author?.node?.acfAuthor?.postAuthorImage?.sourceUrl}')`,
              }}
            />
          )}
        </div>

        <div className="single-post-main__author__right">
          <div className="single-post-main__author-inner">
            <div>
              <h3>{data?.author?.node?.acfAuthor?.postAuthorName}</h3>
              <small>{data?.author?.node?.acfAuthor?.postAuthorPosition}</small>
            </div>
          </div>
          {data?.author?.node?.acfAuthor?.postAuthorDescription && (
            <div className="single-post-main__author-description">
              {data?.author?.node?.acfAuthor?.postAuthorDescription}
            </div>
          )}
          {data?.author?.node?.acfAuthor?.postAuthorLink && (
            <a
              href={data?.author?.node?.acfAuthor?.postAuthorLink}
              className="button button--orange button--small"
            >
              Przeczytaj o autorze
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostAuthor;
